/**
 * Returns the URL for a team logo.
 *
 * Logos are served as static files from public/logos/ for browser caching,
 * instead of being bundled into JavaScript via require().
 *
 * If the logo value starts with 'http', it's already an external URL.
 * Otherwise, it's a filename in public/logos/.
 */
export function getLogoUrl(logo) {
  if (!logo) return '';
  if (logo.startsWith('http')) return logo;
  // Add .svg extension if no extension present
  const filename = logo.includes('.') ? logo : `${logo}.svg`;
  return `/logos/${filename}`;
}
